<template>
  <div>
    <div class="mb-12 to-hide">
      <div class="mb-2">
        <div class="page-title mb-2">ติดตามความก้าวหน้า Fundamental</div>
        <div class="d-flex justify-space-between align-center mb-3">
          <div class="d-flex align-center font-type-bold txt-head black--text">
            <Iconify
              icon="ion:mail-unread"
              color="var(--theme-color-one)"
              class="mr-3"
            ></Iconify>
            รายงานผลการดำเนินการ
          </div>
          <Button theme="8" @click.native="print()" v-if="$route.query.preview">
            <Iconify
              style="color: #e51610"
              icon="fluent:document-pdf-24-filled"
            ></Iconify>
            Export PDF
          </Button>
        </div>
      </div>
      <divcard class="d-flex justify-space-between mb-2" style="gap: 24px">
        <div style="width: 66%">
          <div class="page-title">
            แบบรายงานผลการดำเนินโครงการและการใช้จ่าย งบประมาณรายเดือน
          </div>
        </div>

        <div class="d-flex" style="gap: 18px">
          <div class="budget-tag">
            <div>ปี งปม.</div>
            <div>{{ fiscal_year || '-' }}</div>
          </div>
        </div>
      </divcard>
      <StatusStep
        v-if="!$route.query.preview"
        :current-step="currentStep"
        :steps="documentSteps"
        @onClick="jumpStep"
      ></StatusStep>
    </div>
    <!--  Form switcher  -->
    <div>
      <FundamentalFormDetail
        v-if="currentStep === 1 && !$route.query.preview"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f1_formKey"
      ></FundamentalFormDetail>
      <FundamentalFormApprovedCredit
        v-if="currentStep === 2"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f2_formKey"
      ></FundamentalFormApprovedCredit>
      <FundamentalFormResult
        v-if="currentStep === 3"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f3_formKey"
      ></FundamentalFormResult>
      <FundamentalFormSuccessEvaluation
        v-if="currentStep === 4"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f4_formKey"
      ></FundamentalFormSuccessEvaluation>
      <FundamentalFormSummary
        v-if="currentStep === 5"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f6_formKey"
      ></FundamentalFormSummary>
    </div>
    <!-- Action buttons -->
    <div class="d-flex justify-space-between to-hide">
      <Button theme="2" @onClick="onCancel">ยกเลิก</Button>

      <div class="flex-center" v-if="!$route.query.preview">
        <Button
          v-if="currentStep !== 1"
          theme="3"
          min-width="120px"
          :disabled="isLoading"
          @onClick="backForm"
        >
          &lt; ย้อนกลับ
        </Button>

        <Button
          theme="4"
          min-width="120px"
          :disabled="isLoading"
          @onClick="saveDraft"
          >บันทึกฉบับร่าง</Button
        >
        <Button
          theme="3"
          min-width="120px"
          :disabled="isLoading || doNotSubmit"
          @onClick="nextForm"
        >
          {{ currentStep === 5 ? "ยื่นโครงการ" : "ถัดไป >" }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import StatusStep from "../../components/StatusStep";
import Button from "../../components/input/Button";
import {
  eventBus,
  toDateFormat,
  toDateRangeFormat,
  validateEmail,
} from "../../plugins/global-funcs";
import { mapState } from "vuex";
import FundamentalFormDetail from "./Fundamental/FundamentalFormDetail";
import FundamentalFormApprovedCredit from "./Fundamental/FundamentalFormApprovedCredit";
import FundamentalFormResult from "./Fundamental/FundamentalFormResult";
import FundamentalFormSuccessEvaluation from "./Fundamental/FundamentalFormSuccessEvaluation";
import FundamentalFormSummary from "./Fundamental/FundamentalFormSummary";
import router from "../../router";

export default {
  name: "ProgressFundamentalForm",
  components: {
    StatusStep,
    Button,
    FundamentalFormDetail,
    FundamentalFormApprovedCredit,
    FundamentalFormResult,
    FundamentalFormSuccessEvaluation,
    FundamentalFormSummary,
  },
  data() {
    return {
      toDateRangeFormat,
      toDateFormat,
      currentStep: 1,
      doNotSubmit: false,
      documentSteps: [
        {
          no: 1,
          name: "รายละเอียด",
        },
        {
          no: 2,
          name: "วงเงินที่ได้รับอนุมัติ",
        },
        {
          no: 3,
          name: "ผลการดำเนินโครงการ",
        },
        {
          no: 4,
          name: "การประเมินผลสำเร็จ",
        },
      ],
      // fundamental form
      formDetail: {},
      formApprovedCredit: {},
      formResult: {},
      formSuccessEvaluation: {},

      masterData: {},
      updateId: undefined,
      f1_formKey: 0,
      f2_formKey: 0,
      f3_formKey: 0,
      f4_formKey: 0,
      f5_formKey: 0,
      f6_formKey: 0,
      plan_code: "",
      fiscal_year: null,
    };
  },
  async created() {
    // if (this.$route.params.id) {
    //   this.retrieveForms();
    // }
    if (this.$route.query.preview) {
      this.summaryForm();
    }

    await this.getMasterData();
    this.retrieveForms();

    //for dev
    // this.currentStep = 1
  },
  beforeDestroy() {
    eventBus.$off("fundamentalFormDetailSend");
    eventBus.$off("fundamentalFormDetail");
    eventBus.$off("fundamentalFormApprovedCreditSend");
    eventBus.$off("fundamentalFormApprovedCreditSetData");
    eventBus.$off("fundamentalFormApprovedCredit");
    eventBus.$off("fundamentalFormResultSend");
    eventBus.$off("fundamentalFormResultSetData");
    eventBus.$off("fundamentalFormResult");
    eventBus.$off("fundamentalFormSuccessEvaluationSend");
    eventBus.$off("fundamentalFormSuccessEvaluationSetData");
    eventBus.$off("fundamentalFormSuccessEvaluation");
    eventBus.$off("fundamentalFormAbleToSubmit");
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
      userInfo: (state) => state.Auth.User,
      fundamentalFormId: (state) => state.Fundamental.id,
    }),
  },
  methods: {
    jumpStep(step) {
      if (step == this.currentStep) return;
      if (this.isLoading) {
        this.$store.commit("General/setModal", {
          title: "Wait a moment.",
          text: "Preparing data please wait...",
          theme: "warning",
          showCancel: false,
          buttonText: "OK",
        });
        return;
      }
      if (this.$route.query.id || this.updateId) {
        this.currentStep = parseInt(step);
        this.$vuetify.goTo("#app");
        this.doNotSubmit = false;
      } else {
        this.$store.commit("General/setModal", {
          title: "Complete this step first!",
          text: "Complete the first step then you can jump",
          theme: "error",
          showCancel: false,
          buttonText: "OK",
        });
      }
    },
    isSameId() {
      return (
        !!this.$route.query.id && this.$route.query.id == this.fundamentalFormId
      );
    },
    backForm() {
      if (this.currentStep <= 1) return;
      // don't save when back from summary page
      if (this.currentStep <= this.documentSteps.length) {
        this.saveDraft();
      }
      this.currentStep -= 1;
      this.doNotSubmit = false;
      this.$vuetify.goTo("#app");
    },
    async nextForm() {
      if (this.currentStep > this.documentSteps.length) {
        await this.saveDraft(true);
        return this.$router.push({ name: "ProgressFundamentalList" });
      }
      let error = await this.saveDraft();
      if (error) return;
      this.currentStep += 1;
      this.$vuetify.goTo("#app");
    },
    async saveDraft(isSubmit = false) {
      // this.requestForm(this.currentStep)
      this.requestForm("all");

      // validate formDetail
      // if (this.currentStep == 1) {
      //   if (
      //     this.formDetail.mobile_phone ||
      //     (this.formDetail.email && !validateEmail(this.formDetail.email))
      //   ) {
      //     this.$store.commit("General/setModal", {
      //       title: "ข้อมูลไม่ถูกต้อง",
      //       text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //       theme: "error",
      //       showCancel: false,
      //       buttonText: "OK",
      //     });
      //     return true;
      //   }
      // }

      let payload = {
        // step 1
        department_name: this.formDetail.department_name,
        project_name_th: this.formDetail.project_name_th,
        reporter_name: this.formDetail.reporter_name,
        position: this.formDetail?.position || "นักวิชาการ",
        department: this.formDetail?.department || "ฝ่ายวิจัยและพัฒนา",
        phone: this.formDetail?.phone,
        fax: this.formDetail?.fax,
        mobile_phone: this.formDetail?.mobile_phone,
        email: this.formDetail?.email,
        status: "Draft",
        operating_activities: this.formDetail?.operating_activities || [],
      };

      let res;
      if (this.$route.query.id || this.updateId) {
        // // case: update
        payload = {
          id: this.$route.query.id || this.updateId,
          payload: {
            // step 1
            ...payload,
            // step 2
            form_fund_budget: this.formApprovedCredit?.form_fund_budget || [],
            project_status:
              this.formApprovedCredit?.project_status || undefined,
            // step 3
            fund_budgets: this.formResult?.fund_budgets || [],
            project_section_plan_id:
              this.masterData?.formFund?.project_section_plan_id,
            project_section_plan: this.formResult?.project_section_plan || {},
            // step 4
            evaluate_by: this.formSuccessEvaluation?.evaluate_by || "",
            evaluate_detail: this.formSuccessEvaluation?.evaluate_detail || "",
            satisfaction: this.formSuccessEvaluation.satisfaction || false,
            satisfaction_detail:
              this.formSuccessEvaluation?.satisfaction_detail || "",
            problem: this.formSuccessEvaluation?.problem || "",
            recommendation: this.formSuccessEvaluation?.recommendation || "",

            form_fund_group_id:
              this.masterData?.formFund?.form_fund_group_id || undefined,
            round: this.masterData.formFund?.round,
            status: isSubmit ? "Submitted" : "Draft",
          },
        };

        res = await this.$apiFire("Fundamental/updateFundamental", payload);
        if (res) {
          console.log("res update", res);
          // success
          this.masterData.formFund = res;
          this.updateFormData(this.currentStep);
          // update component with changing key
          this.f1_formKey += 1;
          this.f2_formKey += 1;
          this.f3_formKey += 1;
          this.f4_formKey += 1;
          this.f5_formKey += 1;
          this.f6_formKey += 1;
        } else {
          // error validate
          return true;
        }
      } else {
        // case: store new
        payload.status = isSubmit ? "Submitted" : "Draft";
        payload.form_fund_group_id = this.$route.query.groupId || undefined;
        payload.fiscal_year = this.fiscal_year;

        res = await this.$apiFire("Fundamental/storeFundamental", payload);

        if (res) {
          this.updateId = res;
          this.$store.commit("Fundamental/setDetailForm", this.formDetail);

          this.$router.push({
            name: "ProgressFundamentalForm",
            query: { id: res.id },
          });
        }
        // update changed data
        this.getMasterData();
      }
    },
    updateFormData(formStep) {
      switch (formStep) {
        case 2:
          eventBus.$emit("fundamentalFormApprovedCreditSetData");
          eventBus.$emit("fundamentalFormApprovedCredit");
          break;
        case 3:
          eventBus.$emit("fundamentalFormResultSetData");
          eventBus.$emit("fundamentalFormResult");
          break;

        case 4:
          eventBus.$emit("fundamentalFormSuccessEvaluationSetData");
          eventBus.$emit("fundamentalFormSuccessEvaluation");
          break;
      }
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit("fundamentalFormDetail");
          break;

        case 2:
          eventBus.$emit("fundamentalFormApprovedCredit");
          break;

        case 3:
          eventBus.$emit("fundamentalFormResult");
          break;

        case 4:
          eventBus.$emit("fundamentalFormSuccessEvaluation");
          break;

        default:
          eventBus.$emit("fundamentalFormDetail");
          eventBus.$emit("fundamentalFormApprovedCredit");
          eventBus.$emit("fundamentalFormResult");
          eventBus.$emit("fundamentalFormSuccessEvaluation");
          break;
      }
    },
    retrieveForms() {
      // detail form
      eventBus.$on("fundamentalFormDetailSend", (form) => {
        this.formDetail = form;
        // keep in storage
        this.$store.commit("Fundamental/setDetailForm", this.formDetail);
      });

      // approved credit form
      eventBus.$on("fundamentalFormApprovedCreditSend", (form) => {
        this.formApprovedCredit = form;
        // keep in storage
        this.$store.commit(
          "Fundamental/setApprovedCreditForm",
          this.formApprovedCredit
        );
      });

      // result form
      eventBus.$on("fundamentalFormResultSend", (form) => {
        this.formResult = form;
        // keep in storage
        this.$store.commit("Fundamental/setResultForm", this.formResult);
      });

      // success evaluation form
      eventBus.$on("fundamentalFormSuccessEvaluationSend", (form) => {
        this.formSuccessEvaluation = form;
        // keep in storage
        this.$store.commit(
          "Fundamental/setSuccessEvaluationForm",
          this.formSuccessEvaluation
        );
      });

      // Allow to submit for the summary page
      eventBus.$on("fundamentalFormAbleToSubmit", (bool) => {
        this.doNotSubmit = !bool;
      });
    },
    async getMasterData() {
      let res;
      if (this.$route.query.id && !this.$route.query.groupId) {
        // edit (wait for api)
        let id = this.$route.query.id;
        res = await this.$apiFire("Fundamental/getEditMasterFundamental", id);
        // update component with changing key
        this.f1_formKey += 1;
        this.f2_formKey += 1;
        this.f3_formKey += 1;
        this.f4_formKey += 1;
        this.f5_formKey += 1;
        this.f6_formKey += 1;
      } else {
        if (this.$route.query.groupId) {
          // create new round
          console.log("");
          let id = this.$route.query.id;
          res = await this.$apiFire("Fundamental/getEditMasterFundamental", id);
        } else {
          // create new project
          res = await this.$apiFire(
            "Fundamental/getEditMasterFundamentalCreate"
          );
        }
        this.f1_formKey += 1;
      }
      // }
      if (res) {
        if (this.$route.query.id && this.$route.query.groupId) {
          // case : create new round
          this.masterData = res;
          this.fiscal_year = this.masterData?.fiscal_year;

          // clear formFund data except department_name and project_name_th
          Object.keys(this.masterData.formFund || {}).forEach((key) => {
            if (key !== "department_name" && key !== "project_name_th") {
              this.masterData.formFund[key] = undefined;
            }
          });

          this.formDetail = {
            department_name: this.masterData?.formFund?.department_name,
            project_name_th: this.masterData?.formFund?.project_name_th,
          };
        } else if (this.$route.query.id && !this.$route.query.groupId) {
          console.log("edit project", res);
          // case : edit project
          this.masterData = res;
          this.fiscal_year = this.masterData?.fiscal_year || this.masterData?.formFund?.fiscal_year;

          let formDetailData = {
            department_name: this.masterData?.formFund?.department_name,
            project_name_th: this.masterData?.formFund?.project_name_th,
            reporter_name: this.masterData?.formFund?.reporter_name,
            position: this.masterData?.formFund?.position,
            department: this.masterData?.formFund?.department,
            phone: this.masterData?.formFund?.phone,
            fax: this.masterData?.formFund?.fax,
            mobile_phone: this.masterData?.formFund?.mobile_phone,
            email: this.masterData?.formFund?.email,
            status: this.masterData?.formFund?.status,
            form_fund_group_id: this.masterData?.formFund?.form_fund_group_id,
            operating_activities:
              this.masterData?.formFund?.operating_activities || [],
          };

          let formApprovedCreditData = {
            form_fund_budget: this.masterData?.formFund?.form_fund_budget || [],
            project_status: this.masterData?.formFund?.project_status,
          };

          let formResultData = {
            project_section_plan_id:
              this.masterData?.formFund?.project_section_plan_id,
            project_section_plan:
              this.masterData?.formFund?.project_section_plan || {},
          };

          let formSuccessEvaluationData = {
            evaluate_by: this.masterData?.formFund?.evaluate_by,
            evaluate_detail: this.masterData?.formFund?.evaluate_detail,
            satisfaction: this.masterData?.formFund?.satisfaction,
            satisfaction_detail: this.masterData?.formFund?.satisfaction_detail,
            problem: this.masterData?.formFund?.problem,
            recommendation: this.masterData?.formFund?.recommendation,
            round: this.masterData?.formFund?.round,
          };

          this.formDetail = formDetailData;
          this.formApprovedCredit = formApprovedCreditData;
          this.formResult = formResultData;
          this.formSuccessEvaluation = formSuccessEvaluationData;
        } else {
          // case : create new project
          this.masterData = res;
          this.fiscal_year = this.masterData?.fiscal_year;
        }
      } else {
        this.onCancel();
      }
    },
    onCancel() {
      if (this.$route.query.redirect) {
        this.$router.push({ name: this.$route.query.redirect });
      } else {
        // back route
        let backRoute = "ProgressFundamentalList";
        switch (this.userRole) {
          case "RSP":
            if (this.isFinal) {
              // RSP P/F
              backRoute = "ProgressFundamentalList";
            } else {
              // RSP S/I
              backRoute = "ProgressFundamentalList";
            }
            break;

          case "สป.อว.":
            if (this.isFinal) {
              // OIC P/F
              backRoute = "ProgressFundamentalList";
            } else {
              // OIC S/I
              backRoute = "ProgressFundamentalList";
            }
            break;

          case "ผู้เชี่ยวชาญ":
            backRoute = "ProgressFundamentalList";
            break;
        }
        this.$router.push({ name: backRoute });
      }
    },
    summaryForm() {
      this.currentStep = 5;
      this.$vuetify.goTo("#app");
    },
    print() {
      //get current date dd-mm-yyyy
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = dd + "-" + mm + "-" + yyyy;

      //change document title
      document.title =
        "Form_Fundamental_" +
        this.userInfo.user_type +
        "_" +
        this.plan_code +
        "_" +
        today;
      let toHide = document.getElementsByClassName("to-hide");
      let pdfPage = document.getElementById("pdf");
      let mainContent = document.getElementById("main");
      let titled = document.getElementsByClassName("titled");
      let toShow = document.getElementsByClassName("to-show");
      let noBoxShadow = document.getElementsByClassName("no-box-shadow");
      let s3p1 = document.getElementsByClassName("s3-p1");
      let s3p1h = document.getElementsByClassName("s3-p1-h");
      let indent_info = document.getElementsByClassName("indent-info");

      //remove all class name indent-info
      for (let i = 0; i < indent_info.length; i++) {
        indent_info[i].style.paddingLeft = "10px";
      }

      //show toShow
      for (let i = 0; i < toShow.length; i++) {
        toShow[i].style.display = "block";
        toShow[i].style.visibility = "visible";
        toShow[i].style.height = "auto";
      }

      //hide toHide
      for (let i = 0; i < toHide.length; i++) {
        toHide[i].style.display = "none";
        toHide[i].style.visibility = "hidden";
      }
      for (let i = 0; i < titled.length; i++) {
        titled[i].style.boxShadow = "none";

        //set box shadow to every child of titled
        let titledChild = titled[i].children;
        for (let j = 0; j < titledChild.length; j++) {
          titledChild[j].style.boxShadow = "none";
        }
      }

      //set no-box-shadow box-shadow to none
      for (let i = 0; i < noBoxShadow.length; i++) {
        noBoxShadow[i].style.boxShadow = "none";

        //set border
        noBoxShadow[i].style.border = "1px solid #F5F5F5";
      }

      //set s3p1 style scale 0.8
      for (let i = 0; i < s3p1.length; i++) {
        s3p1[i].style.transform = "scale(0.75)";
        s3p1[i].style.transformOrigin = "top left";
        s3p1[i].style.alignItems = "flex-start";

        //remove class overflow-x-auto
        s3p1[i].classList.remove("overflow-x-auto");
      }
      //set s3p1h style height
      for (let i = 0; i < s3p1h.length; i++) {
        s3p1h[i].style.height = "auto";
      }

      // pdfPage.style.minWidth = '600px'
      pdfPage.style.width = "750px";
      mainContent.style.paddingLeft = 0;
      mainContent.style.backgroundColor = "#fff";

      window.print();

      //reload
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;
}
</style>
